import IconArrowDown from "@/app/(components)/generics/Icons/IconArrowDown";
import styles from "./SectionArrow.module.css";

export default function SectionArrow() {
  return (
    <div className={styles.container} aria-hidden="true">
      <span className={styles.arrow}>
        <IconArrowDown size={34} />
      </span>
    </div>
  );
}
